import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { saveAs } from 'file-saver';

import { ApiBase } from './base-api.service';
import { HelpFile } from '~core/model';
import { HelpFiles } from '~shared/utils/help-files';
import { environment } from 'environments/environment';

@Injectable()
export class StaticDataService extends ApiBase {

  getHelpFiles(): HelpFile[] {
    return HelpFiles;
  }

  downloadHelpFiles(file: HelpFile) {
    const headers = new HttpHeaders({ 'Accept': 'application/pdf' });
    const options = { headers: headers, responseType: 'arraybuffer', observe: 'response' };

    return this.get(`${environment.staticFiles}/help/${file.serverName}`, options, null, false, null, false)
      .map((resp: Response) => {
        const pdfBlob = new Blob([resp.body], {
          type: 'application/pdf'  // must match the Accept type
        });
        saveAs(pdfBlob, file.downloadName);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/staticdata.service.ts